import Modal from 'react-modal'
import {
  CloseIcon,
  customModalStyles,
  LeftIconWrapper,
  ModalBody,
  ModalHeader,
  ModalHeading,
  ModalWrapper,
} from './CustomModal.styled'
import { useLockScroll } from '@src/hooks/useLockScroll'
import { CloseButton } from '../CloseButton'

interface CustomModalProps {
  isOpen: boolean
  onClose: () => void
  leftIcon?: React.ReactNode
  children: React.ReactNode
  heading: string
  customWidth?: string
  fullScreen?: boolean
}

const CustomModal = ({
  isOpen,
  onClose,
  leftIcon,
  children,
  heading,
  customWidth = '350px',
  fullScreen = false,
}: CustomModalProps) => {
  useLockScroll(isOpen)

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      style={customModalStyles(customWidth, fullScreen)}
    >
      <ModalWrapper fullScreen={fullScreen}>
        <ModalHeader>
          {leftIcon && <LeftIconWrapper>{leftIcon}</LeftIconWrapper>}
          <ModalHeading>{heading}</ModalHeading>
          <CloseIcon>
            <CloseButton onClick={onClose} size="sm" />
          </CloseIcon>
        </ModalHeader>
        <ModalBody fullScreen={fullScreen}>{children}</ModalBody>
      </ModalWrapper>
    </Modal>
  )
}

export default CustomModal
